<template>
  <div>
    <tab-title :tabList="tabList" url="workPlan"></tab-title>
    <div class="router-section">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import TabTitle from '@/components/TabTitle'
export default {
  name: 'WorkPlan',
  components: { TabTitle },
  data () {
    return {
      tabList: [{
        label: '养护计划',
        name: 'planList'
      }, {
        label: '养护日报',
        name: 'dailyReport'
      }, {
        label: '任务工单',
        name: 'taskOrder'
      }]
    }
  },
  created () {
    // ...
  },
  methods: {
  }
}
</script>

<style scoped lang='scss'>
  .router-section {
    padding: 10px;
  }
</style>
